// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".oMacxBCFb7ap429VEyCA{opacity:0}.JzZnCMZLyJuV5VX_RU3_{opacity:1}", "",{"version":3,"sources":["webpack://./src/javalab/neighborhood/neighborhood-visualization-column.module.scss"],"names":[],"mappings":"AAAA,sBACE,SAAA,CAGF,sBACE,SAAA","sourcesContent":[".collapsed {\n  opacity: 0;\n}\n\n.expanded {\n  opacity: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"collapsed": "oMacxBCFb7ap429VEyCA",
	"expanded": "JzZnCMZLyJuV5VX_RU3_"
};
export default ___CSS_LOADER_EXPORT___;
